import Reveal from '@/components/base/Reveal';

const barHeights = ['h-4', 'h-6', 'h-8', 'h-10'];

const highlights = [
  'Продвигаем сообщества на разных площадках, а также сайты и каналы — знаем алгоритмы и форматы каждой платформы',
  'Собственная команда: таргетологи, аналитики и контент-мейкеры в одном проекте',
  'Понятные KPI для каждого клиента: подписчик, охват и стоимость заявки',
];

export default function AboutIntro() {
  return (
    <section className="relative w-full px-5 md:px-10 pt-16 md:pt-20 pb-20 md:pb-28">
      <div className="max-w-6xl mx-auto">
        {/* Hero with pulsing badge */}
        <div className="text-center max-w-3xl mx-auto">
          <Reveal>
            <div className="relative inline-flex">
              <span className="absolute -inset-6 rounded-full bg-primary-500/20 blur-2xl animate-glow-pulse"></span>
              <span className="absolute inset-0 rounded-full bg-primary-500/40 animate-ping"></span>
              <span className="absolute inset-0 rounded-full bg-primary-500/25 animate-ping" style={{ animationDelay: '0.6s' }}></span>
              <span className="relative w-24 h-24 md:w-28 md:h-28 rounded-full border-2 border-primary-500/50 bg-background-100/80 backdrop-blur flex items-center justify-center">
                <span className="flex items-end justify-center gap-[3px] h-14">
                  {barHeights.map((height, index) => (
                    <span
                      key={height}
                      className={`${height} w-[4px] rounded-full bg-gradient-to-t from-accent-500 to-primary-300`}
                      style={{ transformOrigin: 'bottom' }}
                    />
                  ))}
                </span>
              </span>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <h1 className="mt-8 font-heading font-bold text-3xl md:text-5xl leading-tight tracking-tight text-foreground-950">
              Мы знаем площадки <span className="text-gold-gradient">глубже</span>, чем просто настройка рекламы
            </h1>
          </Reveal>
          <Reveal delay={180}>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              STRATEGIX — агентство, которое продвигает сообщества на разных площадках, а также
              сайты и каналы. Мы соединяем рекламу, контент и аналитику в одну систему, чтобы
              сообщество росло стабильно, а не рывками.
            </p>
          </Reveal>
        </div>

        {/* Story + highlights */}
        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <Reveal>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              За семь лет работы мы продвинули более 240 сообществ: от небольших городских пабликов
              до сеток крупных брендов. И за это время выработали подход, где каждое действие
              опирается на данные, а не на догадки.
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              Мы не «крутим рекламу ради подписчиков» — мы выстраиваем сообщество как инструмент,
              который стабильно приводит клиентов и окупает вложения.
            </p>
          </Reveal>
          <ul className="space-y-4">
            {highlights.map((item, index) => (
              <Reveal key={item} delay={index * 100}>
                <li className="flex items-start gap-3">
                  <span className="mt-0.5 w-7 h-7 flex-none flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                    <i className="ri-check-line text-base"></i>
                  </span>
                  <span className="text-sm text-foreground-800 leading-relaxed">{item}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}